import { Guidelines } from "@sisuwellness/utilities";
import { theme } from "@sisuwellness/ui/src/theme";

/**
 * @param {number} score Health Risk Score
 * @returns {String} Recommendation for specified score
 */
export const getHRARecommendation = score => {
    if (score === null || score === undefined)
        return "Calculate your Health Risk Score in under 8-minutes to understand what areas of your health could be at risk and how to improve them.";
    else {
        const guideline = new Guidelines.HealthRiskAssessment.Guideline(score).key;
        switch (guideline) {
            case "excellent":
                return "An excellent rating means your results are well above average and exceed national guidelines, such as physical activity and nutrition.";
            case "good":
                return "Achieving a ‘Good’ rating will likely mean your lifestyle and health is in line with national guidelines.";
            case "moderate":
                return "The average rating people receive, which ideally should be improved to ensure all national guidelines are met.";
            case "atRisk":
                return "Scoring an ‘At Risk’ rating means your results are below the average person and need to be improved to reduce risk of chronic disease.";
            case "increasedRisk":
                return "You are at Increased Risk of chronic disease and poor health if you score below 50. Our report will help identify steps to take to improve this.";
            default:
                return "Calculate your Health Risk Score in under 8-minutes to understand what areas of your health could be at risk and how to improve them.";
        }
    }
};

/**
 * @param {number} score Health Risk Score
 * @returns {String} colour code with respect to guideline
 */
export const getHRARiskColor = score => {
    if (Number.isFinite(score)) {
        const guideline = new Guidelines.HealthRiskAssessment.Guideline(score);
        return theme.guidelines["SiSUHealthRiskAssessment"][guideline.key].sisuPortal.hex;
    }
    return theme.colours.hpPrimaryPurple.hex;
};
